import _ from 'lodash'
import constants from 'lib/constants'

const STAFF_ROLE = 'STAFF'
const VENDOR_ROLE = 'VENDOR'
const CLOZ_ADMIN_ROLE = 'CLOZ_ADMIN'
const PROVIDER_ROLE = 'PROVIDER'
const PATIENT_ROLE = 'PATIENT'

const imageNameRegEx = /(\d+)_(\d+).jpg/

export function isUserAdmin (user) {
  return _.get(user, 'is_admin') || _.get(user, 'admin')
}

export function isUserStaff (user) {
  return _.get(user, 'data.role') === STAFF_ROLE || _.get(user, 'is_admin') || _.get(user, 'admin')
}

export function isUserVendor (user) {
  return _.get(user, 'data.role') === VENDOR_ROLE
}

export function isUserOrgAdmin (user) {
  return _.get(user, 'data.role') === CLOZ_ADMIN_ROLE
}

export function isUserProvider (user) {
  return _.get(user, 'data.role') === PROVIDER_ROLE
}

export function isUserPatient (user) {
  return _.get(user, 'data.role') === PATIENT_ROLE
}

export function isDeviceActive (device) {
  return new Date() - new Date(device.last_active) < 5 * 60 * 1000
}

export function isDeviceLensShaded (device) {
  return device.data && _.size(device.data.lens_shading_history) > 0
}

export function isDeviceWorkingOnJob (job) {
  const deviceWorkStatuses = [constants.JOB_STATUSES.QUEUED, constants.JOB_STATUSES.IMAGING, constants.JOB_STATUSES.UPLOADING]
  return job && _.indexOf(deviceWorkStatuses, job.job_status) >= 0
}

export function isJobDone (job) {
  return job && (job.status === 1 || job.error_message)
}

export function truncateString (sourceString, maxLength) {
  if (sourceString.length > maxLength) {
    return `${sourceString.substring(0, maxLength - 3)}...`
  } else {
    return sourceString
  }
}

export function getLinacPositionFromImageName (imageName) {
  return imageName.match(imageNameRegEx)[1]
}

export function getZPosFromImageName (imageName) {
  return imageName.match(imageNameRegEx)[2]
}

export function getDateInputValue () {
  var local = new Date()
  local.setMinutes(local.getMinutes() - local.getTimezoneOffset())
  return local.toJSON().slice(0, 10)
}

export function getMACAddress(deviceString, wifi=true) {
  // cast to hex int
  let macEnding = parseInt(deviceString.substring(deviceString.length - 6), 16);
  // xor last 6 bytes of serial number if WiFi
  if (wifi) {
    macEnding = macEnding  ^ 0x555555;
  }

  // prepend raspberry pi OUI
  let macAddr = "B827EB" + macEnding.toString(16);
  macAddr = macAddr.replace(/..\B/g, '$&:');
  return macAddr;
}



// WEBPACK FOOTER //
// ./src/lib/helpers.js